import { useMemo } from 'react';
import { useLazyQuery } from '@apollo/client';
import ILT_CODES from '../queries/ILT_CODES';
 
const useILTCodes = () => {
    const [ fetchCodes, { data, loading, error } ] = useLazyQuery( ILT_CODES );
    
    const codes = useMemo( () => {
        if ( loading || error || !data || !data.completionCodes?.edges ) { return; }
        
        try {
            return data.completionCodes.edges.map( i => ( {
                key: i.node.id,
                ...i.node
            } ) );
        } catch ( error ) {
            console.error( 'Error loading codes', error ); 
            return [];
        }
    }, [ data ] );
    
    const loadCodes = ( iltID ) => {
        const vars = {
            variables: {
                iltID
            }, 
            fetchPolicy: 'network-only' 
        };

        return fetchCodes( vars );
    };

   
    return useMemo( () => {
        return {
            codes,
            loadCodes,
            codesError: error,
            codesLoading: loading, 
        };
    }, [ codes, error, loading ] );
};

export default useILTCodes;
